
// TODO_REPLACE(If using i18n multi language support, move this to ./src/config/executors/i18n-resources)

// Forgot Password
export const TXT_FORGOT_PASSWORD_EMAIL_TITLE = 'Forgot your password ?';
export const TXT_FORGOT_PASSWORD_EMAIL_SUCCESS = 'An email with further instructions has been sent to you.';
export const TXT_FORGOT_PASSWORD_PASSWORD_TITLE = 'Set a new password';
export const TXT_FORGOT_PASSWORD_PASSWORD_SUCCESS = 'You can now login with your new password.';

// Page not found
export const TXT_PAGE_NOT_FOUND = 'Oops, this page does not exist !';

// SEO
export const PUBLIC_PAGE_DEFAULT_DESC = 'We provide an extensive portfolio of moving, handling and bathing solutions across our Prism, Freeway and Mackworth ranges, meaning we can cater for a wide variety of client needs, environments and budgets. Ensuring safety and comfort for carers and clients alike, as well as providing dignity and a measure of independence, our products can greatly improve quality of life.';
